import { render, staticRenderFns } from "./BeneficiaryAccountUpdate.vue?vue&type=template&id=ac3d8bd2&scoped=true"
import script from "./BeneficiaryAccountUpdate.vue?vue&type=script&lang=js"
export * from "./BeneficiaryAccountUpdate.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryAccountUpdate.vue?vue&type=style&index=0&id=ac3d8bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3d8bd2",
  null
  
)

export default component.exports